import { render, staticRenderFns } from "./WritingEditor.vue?vue&type=template&id=985184d4&scoped=true"
import script from "./WritingEditor.vue?vue&type=script&lang=js"
export * from "./WritingEditor.vue?vue&type=script&lang=js"
import style0 from "./WritingEditor.vue?vue&type=style&index=0&id=985184d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985184d4",
  null
  
)

export default component.exports